/* Phones: lift the Shopify chat button above the bottom navigation bar so it no longer covers the right-most icon.
   The chat widget (<shopify-chat>) is created after the page loads and keeps its button inside an open shadow root;
   only the button is moved (the chat window is a separate part and stays where it is). */
(function () {
  var CSS = '@media (max-width: 749px){ shopify-agent-runtime::part(activator){ translate: 0 -64px; } }';
  function apply() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById('piv-chat-lift')) return true;
    var st = document.createElement('style');
    st.id = 'piv-chat-lift';
    st.textContent = CSS;
    host.shadowRoot.appendChild(st);
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () {
    if (apply() || ++tries > 80) clearInterval(timer);   // keep looking for up to ~40 seconds
  }, 500);
})();
